import { AUMFundSize, MFCategoriesCode, MFSchemesPlanTypes, MFSchemsPlanes, } from "@domains/features/Markets/MutualFunds/entities/MFCommon";
export var MutualFundsSchemesConfig = {
    equity: {
        limit: 3,
        // rating: MorningStarRatings.RATING_FOUR,
        fundSize: AUMFundSize.AUM_300_CR,
        sch_type: MFSchemsPlanes.GROWTH,
        schPlan: MFSchemesPlanTypes.REGULAR,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: [2, 4, 1, 3, 7, 8, 9],
        amcFunds: [],
    },
    hybrid: {
        limit: 3,
        // rating: MorningStarRatings.RATING_FOUR,
        fundSize: AUMFundSize.AUM_300_CR,
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.HYBRID,
        subCatCode: [30, 31],
    },
    "tax-saving": {
        limit: 3,
        // rating: MorningStarRatings.RATING_FOUR,
        fundSize: AUMFundSize.AUM_300_CR,
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: [11],
    },
    "morning-star-top-rated": {
        // rating: MorningStarRatings.RATING_FIVE,
        fundSize: AUMFundSize.AUM_300_CR,
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: [2, 4, 1, 3, 7, 8, 9],
    },
    "best-performing-sip": {
        // rating: MorningStarRatings.RATING_FOUR,
        fundSize: AUMFundSize.AUM_300_CR,
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: [2, 4, 1, 3, 7, 8, 9],
    },
    "high-risk-high-return": {
        // rating: MorningStarRatings.RATING_FOUR,
        fundSize: AUMFundSize.AUM_300_CR,
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: [4, 5],
    },
    "long-term": {
        // rating: MorningStarRatings.RATING_FOUR,
        fundSize: AUMFundSize.AUM_300_CR,
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: [2],
    },
    "low-cost-index": {
        // rating: MorningStarRatings.RATING_FOUR,
        fundSize: AUMFundSize.AUM_300_CR,
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
    },
    "nifty-50": {
        // rating: "",
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
        benchmark: ["Nifty 50 TRI"],
    },
    "nifty-bank": {
        // rating: "",
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
        benchmark: ["Nifty Bank TRI"],
    },
    "large-and-mid": {
        // rating: "",
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
    },
    midcap: {
        // rating: "",
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
        benchmark: ["Nifty Midcap 150 TRI"],
    },
    "small-cap": {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
        benchmark: ["Nifty Smallcap 50 TRI", "Nifty Smallcap 250 TRI"],
    },
    "nifty-100": {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
        benchmark: ["Nifty 100 TRI"],
    },
    "nifty-next-50": {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
        benchmark: ["Nifty Next 50 TRI"],
    },
    "BSE-Sensex": {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.OTHERS,
        subCatCode: [37],
        benchmark: ["BSE Sensex TRI"],
    },
    banking: {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["Nifty Financial Services TRI"],
    },
    infrastructure: {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["Nifty Infrastructure TRI", "BSE India Infrastructure TRI"],
    },
    technology: {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["Nifty IT TRI", "BSE Tech TRI"],
    },
    healthcare: {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["BSE Healthcare TRI"],
    },
    "environmental-social-and-Governance": {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["Nifty 100 ESG TRI"],
    },
    "consumption-and-demand": {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["Nifty India Consumption TRI"],
    },
    psu: {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["BSE PSU TRI"],
    },
    "multi-national-company": {
        fundSize: "",
        schPlan: MFSchemesPlanTypes.REGULAR,
        sch_type: MFSchemsPlanes.GROWTH,
        catCode: MFCategoriesCode.EQUITY,
        subCatCode: ["10"],
        benchmark: ["Nifty MNC TRI"],
    },
};
